import { render, staticRenderFns } from "./AutorHeader.vue?vue&type=template&id=241ead45"
import script from "./AutorHeader.vue?vue&type=script&lang=js"
export * from "./AutorHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports